export default function ChevronDownIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12.5859L15.5859 9H17V10.4141L12 15.415L7 10.4141V9H8.41406L12 12.5859Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
